import React, { useState, useEffect } from "react";
import "../../CSS/TasksPage.css";
import {
  Navbar,
  Button,
  AddTeamTaskForm,
  TaskCard,
} from "../../components/indexComponents";
import { useParams } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function TeamTasksPage() {
  const { teamId } = useParams();
  const [team, setTeam] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [clients, setClients] = useState([]);
  const [addTaskForm, setAddTaskForm] = useState(false);
  const [isMember, setIsMember] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [numberOfMember, setNumberOfMember] = useState(0);

  /* #region  Obtenir les informations de l'équipe  */
  const getTeamInfo = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/team/${teamId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 403) {
        setIsMember(false);
        setIsLoading(false);
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to fetch team informations");
      }

      const data = await response.json();
      setTeam(data);
      const tempArray = [...data.Team_Tasks];
      setTasks(tempArray);
      const tempArrayClients = [...data.Team_Clients];
      setClients(tempArrayClients);
      setIsLoading(false);
      const tempArrayMember = data.Team_Members.length;
      setNumberOfMember(tempArrayMember);
    } catch (error) {
      console.error("Error getting team information:", error);
    }
  };
  useEffect(() => {
    getTeamInfo();
  }, []);

  /* #endregion */
  return (
    <div id="TasksPage" className="page-frame">
      <Navbar />
      <div className="TasksPage-frame page-content">
        <Button
          icon={faArrowLeft}
          route={`/team/${teamId}`}
          className="back-btn"
        />
        {!isLoading ? (
          <>
            {isMember ? (
              <>
                <h1>Tâches actives de l'équipe</h1>
                {addTaskForm ? (
                  ""
                ) : (
                  <Button
                    className="add-task-btn"
                    text="Ajouter une tache"
                    onClick={(e) => setAddTaskForm(true)}
                  />
                )}
                {addTaskForm ? (
                  <AddTeamTaskForm
                    cancelBtnOnClick={(e) => setAddTaskForm(false)}
                    teamId={teamId}
                    onTaskAdded={getTeamInfo}
                    teamInfo={team}
                  />
                ) : (
                  <div></div>
                )}{" "}
                {/* onTaskAdded={refreshTasks} */}
                <div className="tache-container">
                  {tasks.map((task) => (
                    <TaskCard
                      key={task.id}
                      refreshTasks={getTeamInfo}
                      task={task}
                      isTeam={true}
                      clients={clients}
                      numberOfMember={numberOfMember}
                    /> /*  refreshTasks={refreshTasks} */
                  ))}
                </div>
              </>
            ) : (
              <>
                <div>
                  <h1>Vous n'êtes pas membre de cette équipe</h1>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <h1>Chargement des tâches...</h1>
          </>
        )}
      </div>
    </div>
  );
}

export default TeamTasksPage;
